import type { TranslationFunction } from '@/app/components/translations/Translation.tsx';

export const resultsFoundText = (t: TranslationFunction, count: number, max = Infinity): string => {
  if (count === 1) return t('vacation.oss.title.stay_found_sing');
  if (count >= max) return t('vacation.oss.title.over_stay_found', { amount: `${max}` });
  return t('vacation.oss.title.stay_found', { amount: `${count}` });
};
